import React, { useState, useEffect, useRef } from 'react';
import { useAppSelector } from 'store/hooks';

import { currentLessonSelector } from 'store/lesson/selectors';
import { currentCourseSelector } from 'store/course/selectors';

import {
  getMatchingPercent,
  getLessonsCount,
} from './ColorMatchLessonPreviewPage.helpers';

import ColorMatchLessonPage from './ColorMatchLessonPreviewPage';

const ColorMatchLessonPageContainer = (props: any) => {
  const course = useAppSelector(currentCourseSelector);
  const lesson = useAppSelector(currentLessonSelector);

  const imageRef = useRef<HTMLDivElement | null>(null);

  const [currentColor, setCurrentColor] = useState(null);
  const [currentImage, setCurrentImage] = useState(null);
  const [matchPercent, setMatchPercent] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [previewType, setPreviewType] = useState('Plugin');
  const [isTestMode, setTestMode] = useState(false);

  const handleColorChange = ({ hex }: { hex: any }) => {
    setCurrentColor(hex);
  };

  const handleCheckColorClick = () => {
    setSubmitted(true);

    const percent = getMatchingPercent(lesson.color, currentColor);

    setMatchPercent(percent);
  };

  console.log(lesson.imageUrl);
  console.log(currentImage);

  useEffect(() => {
    if (lesson) {
      fetch(lesson.imageUrl)
        .then((response: any) => response.text())
        .then((response: any) => {
          setCurrentImage(response);
        });
    }
  }, [lesson]);

  useEffect(() => {
    if (imageRef.current && currentColor) {
      const svgImage = imageRef.current?.children?.[0] as
        | HTMLElement
        | undefined;

      if (svgImage) {
        svgImage.style = `color: ${currentColor}`;
      }
    }
  }, [currentColor, currentImage, imageRef]);

  return (
    <ColorMatchLessonPage
      {...props}
      submitted={submitted}
      imageRef={imageRef}
      lesson={lesson}
      currentColor={currentColor}
      currentImage={currentImage}
      matchPercent={matchPercent}
      onColorChange={handleColorChange}
      onCheckColorClick={handleCheckColorClick}
      previewType={previewType}
      setPreviewType={setPreviewType}
      isTestMode={isTestMode}
      setTestMode={setTestMode}
      lessonTitle={lesson.title}
      currentLesson={getLessonsCount(course, lesson).lessonIndex}
      lessonsCount={getLessonsCount(course, lesson).totalLessons}
    />
  );
};

export default React.memo(ColorMatchLessonPageContainer) as any;
